

import React from "react";
import SignIn from "views/auth/SignIn";
import {
  MdHome,
  MdHealthAndSafety,
  MdStore,
  MdOutlinePedalBike,
  MdOutlineShoppingBasket,
  MdAddLocation,
  MdAddBusiness,
  MdSavedSearch,
  MdSettings,
  MdLocalOffer,
  MdCategory,
  MdTimeline,
  MdPayments,
  MdAssignment,
  MdPeople,
  MdList,
  MdHistory,
  MdRoom,
  MdSupervisorAccount,
  MdPets,
  MdApi,
  MdCode,

} from "react-icons/md";
import { FaUsers, FaCoins, FaUserMd, FaFlask } from "react-icons/fa";

import { AiOutlinePoweroff } from "react-icons/ai";
import Dashboard from "views/admin/Dashboard/Dashboard";
import Partners from "views/admin/Partners/Partners";
import Category from "views/admin/Category/Category";
import Subcat from "views/admin/Category/Subcat";
import OpenOrders from "views/admin/OpenOrders";
import OrderHistory from "views/admin/OrderHistory";
import Sales from "views/admin/Sales";
import UserDetails from "views/admin/UserDetails";
import PharmacyPartners from "views/admin/PharmacyPartners";
import DeliveryPartners from "views/admin/DeliveryPartners";
import PharmacyPayoutReq from "views/admin/PharmacyPayoutReq";
import DeliveryPayoutReq from "views/admin/Delivery Payout Req";
import PincodeSrc from "views/admin/Dashboard/PincodeSrc";
import ReferPharmacy from "views/admin/newScreen/ReferPharmacy";
import Searchhistories from "views/admin/Dashboard/components/Searchhistories";
import SearchHistoriespincode from "views/admin/Dashboard/components/SearchHistoriespincode";
import AdminController from "views/admin/Dashboard/AdminController";
import CreditWallet from "views/admin/Dashboard/CreditWallet";
import OfferList from "views/admin/Dashboard/OfferList";
import Entities from "views/admin/Dashboard/Entities";
import Categorylist from "views/admin/Dashboard/NewCategory/Categorylist";
import Systemstatus from "views/admin/SystemStatus/Systemstatus";
import PetCare from "views/admin/PetCare/PetCare";
import ApiClientManagement from "views/admin/Dashboard/ApiClientManagement";
import { LineChartIcon } from "lucide-react";
import AppAnalyticsDashboard from "views/admin/Dashboard/appAnalytics/AppAnalyticsDashboard";
import Enquiries from "views/admin/ModernMedicine/Enquiries";
import LabTests from "views/admin/LabTests/LabTests";
import LabOrders from "views/admin/LabOrders/LabOrders";
import ServiceableAreas from "views/admin/ServiceableAreas/ServiceableAreas";
import LocalDeliveryPricing from "views/admin/localDelivery/Pricing";
import LocalDeliveryLiveOps from "views/admin/localDelivery/LiveOps";

// You can freely adjust the icon per your app preferences!
const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <MdHome className="h-6 w-6" />,
    component: <Dashboard />,
  },
  {
    name: "App Analytics",
    layout: "/admin",
    path: "app-analytics",
    icon: <LineChartIcon className="h-6 w-6" />,
    component: <AppAnalyticsDashboard />,
  },
  {
    name: "Open Orders",
    layout: "/admin",
    path: "open-orders",
    icon: <MdAssignment className="h-6 w-6" />,
    component: <OpenOrders />,
    private: true,
  },
  {
    name: "Orders History",
    layout: "/admin",
    path: "orders-history",
    icon: <MdHistory className="h-6 w-6" />,
    component: <OrderHistory />,
    private: true,
  },
  {
    name: "Nura-health enquiries",
    layout: "/admin",
    path: "nura-health",
    icon: <FaUserMd className="h-6 w-6" />,
    component: <Enquiries />,
    section: "Nura-health enquiries",
  },
  {
    name: "Lab Tests & Packages",
    layout: "/admin",
    path: "lab-tests",
    icon: <FaFlask className="h-6 w-6" />,
    component: <LabTests />,
  },
  {
    name: "Lab Orders",
    layout: "/admin",
    path: "lab-orders",
    icon: <MdAssignment className="h-6 w-6" />,
    component: <LabOrders />,
    private: true,
  },
  {
    name: "Payments Details",
    layout: "/admin",
    path: "sales",
    icon: <MdPayments className="h-6 w-6" />,
    component: <Sales />,
    private: true,
  },
  {
    name: "Pharmacy Payouts",
    layout: "/admin",
    // Path unchanged — existing bookmarks and links keep working.
    path: "pharmacy-payout-req",
    icon: <FaCoins className="h-6 w-6" />,
    component: <PharmacyPayoutReq />,
    private: true,
  },
  {
    name: "Delivery Payout Req",
    layout: "/admin",
    path: "delivery-payout-req",
    icon: <MdTimeline className="h-6 w-6" />,
    component: <DeliveryPayoutReq />,
  },
  {
    // The merge of what used to be two sidebar entries, "Pharmacy Partner"
    // (a paged table) and "Pharmacy Details" (an unpaged table plus a map).
    // Both old paths still resolve to this page — see layouts/admin/index.jsx.
    name: "Pharmacy Partners",
    layout: "/admin",
    path: "pharmacy-partners",
    icon: <MdStore className="h-6 w-6" />,
    component: <PharmacyPartners />,
  },
  {
    name: "Refer Pharmacy",
    layout: "/admin",
    path: "referPharmacy",
    icon: <MdAddBusiness className="h-6 w-6" />,
    component: <ReferPharmacy />,
    style: { display: "none" },
  },
  {
    // The merge of what used to be two sidebar entries, "Delivery Boys
    // Location" (an unpaged table plus a map) and "Delivery Partner Details"
    // (a paged table). Both old paths still resolve to this page — see
    // layouts/admin/index.jsx.
    name: "Delivery Partners",
    layout: "/admin",
    path: "delivery-partners",
    icon: <MdOutlinePedalBike className="h-6 w-6" />,
    component: <DeliveryPartners />,
  },
  {
    name: "Medicines",
    layout: "/admin",
    path: "partners",
    icon: <MdHealthAndSafety className="h-6 w-6" />,
    component: <Partners />,
  },
  {
    name: "Pet Care",
    layout: "/admin",
    path: "pet-care",
    icon: <MdPets className="h-6 w-6" />,
    component: <PetCare />,
  },
  {
    name: "User Details",
    layout: "/admin",
    path: "user-details",
    icon: <MdPeople className="h-6 w-6" />,
    component: <UserDetails />,
  },
  {
    name: "Categories",
    layout: "/admin",
    path: "category",
    icon: <MdCategory className="h-6 w-6" />,
    component: <Categorylist />,
  },
  {
    name: "Pincode Requests",
    layout: "/admin",
    path: "Pincode",
    icon: <MdAddLocation className="h-6 w-6" />,
    component: <PincodeSrc />,
    style: { display: "none" },
  },
  {
    name: "Serviceable Pincodes",
    layout: "/admin",
    path: "serviceable-areas",
    icon: <MdAddLocation className="h-6 w-6" />,
    component: <ServiceableAreas />,
  },
  {
    name: "Search Histories",
    layout: "/admin",
    path: "Searchhistories",
    icon: <MdSavedSearch className="h-6 w-6" />,
    component: <Searchhistories />,
    style: { display: "none" },
  },
  {
    name: "User Searches",
    layout: "/admin",
    path: "SearchHistoriespincode",
    icon: <MdRoom className="h-6 w-6" />,
    component: <SearchHistoriespincode />,
    style: { display: "none" },
  },
  {
    name: "Admin Controller",
    layout: "/admin",
    path: "admin-controller",
    icon: <MdSupervisorAccount className="h-6 w-6" />,
    component: <AdminController />,
    style: { display: "none" },
  },
  {
    name: "Coupons",
    layout: "/admin",
    path: "coupons",
    icon: <MdLocalOffer className="h-6 w-6" />,
    component: <OfferList />,
    style: { display: "none" },
  },
  {
    name: "Entities",
    layout: "/admin",
    path: "entities",
    icon: <MdList className="h-6 w-6" />,
    component: <Entities />,
    style: { display: "none" },
  },
  {
    name: "System Status",
    layout: "/admin",
    path: "systemstatus",
    icon: <MdSettings className="h-6 w-6" />,
    component: <Systemstatus />,
    style: { display: "none" },
  },
  {
    name: "Api Client management",
    layout: "/admin",
    path: "apiclientmanagement",
    icon: <MdCode className="h-6 w-6" />,
    component: <ApiClientManagement />,
    style: { display: "none" },
    // style: { display: "none" },
    //@ts-check
  },
  {
    name: "Parcel Delivery — Pricing",
    layout: "/admin",
    path: "local-delivery/pricing",
    icon: <MdPayments className="h-6 w-6" />,
    component: <LocalDeliveryPricing />,
    section: "Parcel Delivery",
  },
  {
    name: "Parcel Delivery — Live Ops",
    layout: "/admin",
    path: "local-delivery/live-ops",
    icon: <MdTimeline className="h-6 w-6" />,
    component: <LocalDeliveryLiveOps />,
    section: "Parcel Delivery",
  },
  {
    name: "Logout",
    layout: "/auth",
    path: "sign-in",
    icon: <AiOutlinePoweroff className="h-6 w-6" />,
    component: <SignIn />,
    isLogout: true,
  },


];

export default routes;
